export default function PHTile({ label, ratio = 1, from, to, kind = 'image', dur }) {
  return (
    <div className="ph" style={{
      aspectRatio: ratio,
      borderRadius: 12,
      border: '1px solid rgba(255,255,255,.08)',
      '--ph-from': from,
      '--ph-to': to,
    }}>
      <div style={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'flex-end', justifyContent: 'space-between', padding: 10, zIndex: 2 }}>
        <span className="mono" style={{ fontSize: 10, color: 'rgba(255,255,255,.7)', letterSpacing: '.05em' }}>{label}</span>
        {kind === 'video' && (
          <span style={{ display: 'flex', alignItems: 'center', gap: 4, fontSize: 10, color: 'rgba(255,255,255,.7)' }}>
            <span style={{ width: 6, height: 6, borderRadius: '50%', background: '#FF4D8D' }}/>
            <span className="mono">{dur || '0:04'}</span>
          </span>
        )}
      </div>
    </div>
  );
}
